export const REMARK_SUBJECT_MAX_LENGTH = 150;
export const REMARK_BODY_MAX_LENGTH = 5000;

const SINGLE_LINE_FORBIDDEN = /[<>\u0000-\u001f\u007f]/g;

const MULTILINE_FORBIDDEN = /[<>\u0000-\u0008\u000b\u000c\u000e-\u001f\u007f]/g;

export const sanitizeRemarkSubject = (value) =>
  String(value ?? "").replace(SINGLE_LINE_FORBIDDEN, "").slice(0, REMARK_SUBJECT_MAX_LENGTH);

export const sanitizeRemarkBody = (value) =>
  String(value ?? "").replace(/\r\n?/g, "\n").replace(MULTILINE_FORBIDDEN, "").slice(0, REMARK_BODY_MAX_LENGTH);
